export default {
  addThisConfig: {
    shareTitle: 'More reasons to celebrate!',
  },
  mainTitle: 'When is your birthday?',
  dateForm: {
    inputLabels: {
      day: 'day',
      month: 'month',
      time: 'time',
      year: 'year',
    },
    submitButton: 'Show my age in seconds, hours or days',
  },
  birthDateBreakdown: {
    subTitle: 'Thanks for filling in!',
    title: 'So this is how old you are:',
    rowsNames: {
      days: 'days',
      hours: 'hours',
      minutes: 'minutes',
      months: 'months',
      seconds: 'seconds',
      weeks: 'weeks',
    },
    nextSectionButton: 'Show my anniversaries',
  },
  occasions: {
    daysAgo: '{value} days ago',
    futureTitle: 'Your future anniversaries',
    inXDays: 'in {value} days',
    old: 'old',
    on: 'on',
    pastTitle: 'Your past anniversaries',
    periodsLabels: {
      days: 'days',
      hours: 'hours',
      minutes: 'minutes',
      months: 'months',
      seconds: 'seconds',
    },
    youLlBe: 'You\'ll be',
    youWere: 'You were',
  },
  futureOccasionsReminders: {
    dateTypes: {
      days: 'days',
      months: 'months',
      seconds: 'seconds',
    },
    remindButton: 'Remind in the Future',
    occasionRemindButton: {
      default: 'Remind me!',
      selected: 'Selected',
    },
    title: 'Future <span>Anniversaries</span>',
  },
  sideControls: {
    pageDownLabel: 'Next page',
    pageUpLabel: 'Previous page',
  },
}
